import React, { useEffect } from "react";
import styled, { ThemeProvider } from "styled-components";
import { Script, ScriptStrategy } from "gatsby";
import Header from "./Header";
import Footer from "./Footer";
import GlobalStyle from "./GlobalStyle";
import theme from "../theme";

const Main = styled.main``;

function Layout({ page, children }) {
  useEffect(() => {
    if (window.LeadBooster) {
      window.LeadBooster.on("opened", () => {
        if (window.dataLayer) {
          window.dataLayer.push({
            event: "chatbotOpen",
          });
        }
      });
    }
  });

  return (
    <>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <Header page={page} />
        <Main>{children}</Main>
        <Footer />
      </ThemeProvider>
      {page.chatbotIdentifier && (
        <>
          <Script id="pipedrive-chat-config">
            {`window.pipedriveLeadboosterConfig = {base: 'leadbooster-chat.pipedrive.com',companyId: 7927681,playbookUuid: '${page.chatbotIdentifier}',version: 2};(function () {var w = window;if (w.LeadBooster) {console.warn('LeadBooster already exists');} else {w.LeadBooster = {q: [],on: function (n, h) {this.q.push({ t: 'o', n: n, h: h });},trigger: function (n) {this.q.push({ t: 't', n: n });},};}})();`}
          </Script>
          <Script
            id="pipedrive-chat-loader"
            src="https://leadbooster-chat.pipedrive.com/assets/loader.js"
          />
        </>
      )}
      <Script id="app-insights-config" strategy={ScriptStrategy.offMainThread}>
        {`
        var appInsights = window.appInsights || function (a) {
          function b(a) { c[a] = function () { var b = arguments; c.queue.push(function () { c[a].apply(c, b) }) } } var c = { config: a }, d = document, e = window; setTimeout(function () { var b = d.createElement("script"); b.src = a.url || "https://az416426.vo.msecnd.net/scripts/a/ai.0.js", d.getElementsByTagName("script")[0].parentNode.appendChild(b) }); try { c.cookie = d.cookie } catch (a) { } c.queue = []; for (var f = ["Event", "Exception", "Metric", "PageView", "Trace", "Dependency"]; f.length;)b("track" + f.pop()); if (b("setAuthenticatedUserContext"), b("clearAuthenticatedUserContext"), b("startTrackEvent"), b("stopTrackEvent"), b("startTrackPage"), b("stopTrackPage"), b("flush"), !a.disableExceptionTracking) { f = "onerror", b("_" + f); var g = e[f]; e[f] = function (a, b, d, e, h) { var i = g && g(a, b, d, e, h); return !0 !== i && c["_" + f](a, b, d, e, h), i } } return c
        }({
          instrumentationKey: 'a0f9e78b-7c5e-49da-800d-7d708b281a2e'
        });

        window.appInsights = appInsights, appInsights.queue && 0 === appInsights.queue.length && appInsights.trackPageView();
        window.appInsights.trackPageView();
        `}
      </Script>
      {/* <!-- Google Tag Manager (noscript) --> */}
      <noscript>
        {`
          <iframe
            src="
            https://www.googletagmanager.com/ns.html?id=GTM-P9MQ6WV"
            height="0"
            width="0"
            style="display:none;visibility:hidden"
          ></iframe>
         `}
      </noscript>
      {/* <!-- End Google Tag Manager (noscript) --> */}
    </>
  );
}

export default Layout;
